<template>
  <div class="infoHeader">
    <div class="infoHeader__message">
      <page-announcement
        v-if="isMounted && editOrderId"
        layout="gray"
        hide-close
        info-text="TRYB EDYCJI"
      >
        <div>
          Znajdujesz się w trybie edycji zamówienia. Wszystkie produkty, które dodasz/usuniesz
          dotyczą tylko zamówienia nr:
          {{ editOrderId }}.
          <button @click="closeEditOrder">Zakończ edycje</button>
        </div>
      </page-announcement>
      <page-announcement
        v-if="acl && acl.switchFrontendVersionUntilDate"
        cookie-name="switchFrontendVersionUntilDate"
      >
        <div>
          Jesteś na nowej wersji sklepu! Możesz wrócić do starej wersji do dnia
          {{ acl.switchFrontendVersionUntilDate }}! Po tej dacie automatycznie przełączymy Cię na
          nową wersję sklepu.
          <button @click="switchFrontendVersion">Przejdź na starą wersję strony.</button>
        </div>
      </page-announcement>
      <page-announcement
        v-if="
          businessVariables &&
          businessVariables.allPagesAnnouncement &&
          !$cookies.get('pageAnnouncement')
        "
      >
        {{ businessVariables.allPagesAnnouncement }}
      </page-announcement>
    </div>
    <div class="infoHeader__inner container">
      <div class="infoHeader__text">
        Darmowa dostawa od:
        <span v-if="businessVariables" class="infoHeader__textBold">
          {{
            showNetPrices
              ? businessVariables.freeShipping.netFormatted
              : businessVariables.freeShipping.grossFormatted
          }}
          {{ businessVariables.freeShipping.currencyPostfix }}
          {{ showNetPrices ? $t('net') : $t('gross') }}
        </span>
        <span v-if="businessVariables?.freeShippingDeliveryMethod"
          >dla {{ businessVariables.freeShippingDeliveryMethod.label }}</span
        >
      </div>
      <div v-if="acl" class="infoHeader__switchPrice">
        <div class="infoHeader__switchPriceText">
          {{ priceSetting.label }}
        </div>
        <form-switch
          :value="acl.showNetPrices"
          name="infoHeaderSwitch"
          :disabled="priceSetting.readOnly"
          class="infoHeader__switch"
          @input="
            onSwitch(priceSetting.id, priceSetting.groupIndex, priceSetting.settingsIndex, $event)
          "
        >
        </form-switch>
      </div>
      <div class="infoHeader__help">
        <div class="infoHeader__helpText">
          <span class="infoHeader__helpIcon icon-help" /> {{ $t('help') }}
        </div>
        <info-dropdown class="infoHeader__dropdown" />
      </div>
      <!--      <nuxt-link-->
      <!--        v-if="$i18n.locale === 'pl'"-->
      <!--        :to="switchLocalePath('en')"-->
      <!--        class="infoHeader__language"-->
      <!--      >-->
      <!--        <img src="/tmp/flaga_gb.svg" alt="" class="infoHeader__languageFlag" /> English-->
      <!--      </nuxt-link>-->
      <nuxt-link
        v-if="$i18n.locale === 'en'"
        :to="switchLocalePath('pl')"
        class="infoHeader__language"
      >
        <img src="/tmp/flaga_gb.svg" alt="" class="infoHeader__languageFlag" /> Polski
      </nuxt-link>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import InfoDropdown from '~/components/InfoDropdown';
import switchMixin from '~/mixins/switchPriceNet';
import PageAnnouncement from '~/components/PageAnnouncement';
import cartMixin from '@/mixins/cart';

export default {
  name: 'InfoHeader',
  components: {
    PageAnnouncement,
    InfoDropdown,
  },
  mixins: [switchMixin, cartMixin],
  data() {
    return {
      isMounted: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['showNetPrices']),
    ...mapState({
      businessVariables: state => state.settings.businessVariables,
      editOrderId: state => state.cart.editOrderId,
    }),
  },
  mounted() {
    this.isMounted = true;
  },
  methods: {
    ...mapMutations({
      setEditOrderId: 'cart/setEditOrderId',
    }),
    closeEditOrder() {
      this.setEditOrderId(null);
      localStorage.removeItem('orderEditId');
      this.getCart();
    },
    async switchFrontendVersion() {
      try {
        const { data } = await this.$axios.get(
          `${this.$config.baseOfixApi}/e-commerce/v1/users/old-frontend-link`,
        );
        // this.$cookies.set('switchFrontendVersionUntilDate', true, {
        //   expires: 30,
        // });
        window.location.href = data.link;
      } catch {}
    },
  },
};
</script>

<style lang="scss">
.infoHeader {
  $root: &;
  position: relative;
  z-index: $zIndexLayer;
  background-color: $cWhite;
  border-bottom: 1px solid $cAddLight;

  &__inner {
    display: flex;

    @include rwd('tablet') {
      display: none;
    }
  }

  &__text {
    padding: 1.4rem 0;
    font-size: 1.2rem;
    line-height: 1.5rem;
    color: $cAddDark02;

    @include rwd('ultra') {
      padding: 1rem 0;
    }
  }

  &__textBold {
    font-weight: 700;
    color: $cMain;
    border-bottom: 1px solid $cMain;
  }

  &__help {
    position: relative;
    display: flex;
    height: auto;
    align-items: center;
    border-left: 1px solid $cAddLight;
    border-right: 1px solid $cAddLight;
    padding: 0 2.3rem;
    font-size: 1.2rem;
    line-height: 1.5rem;
    font-weight: 600;
    color: $cAddDark02;
    cursor: pointer;

    &:hover {
      background-image: linear-gradient(180deg, #ffffff 0%, #f7f8fc 100%);
      #{$root}__helpText {
        &:after {
          transform: rotate(180deg);
        }
      }

      #{$root}__dropdown {
        top: 100%;
        opacity: 1;
        pointer-events: all;
      }
    }
  }

  &__helpText {
    display: flex;
    align-items: center;

    &:after {
      position: relative;
      @include icomoon('chevron-down');
      font-size: 7px;
      margin-left: 1rem;
      transition: transform $tr;
    }
  }

  &__helpIcon {
    font-size: 1.7rem;
    margin-right: 1rem;
  }

  &__switchPrice {
    @extend #{$root}__help;
    margin-left: auto;
  }

  &__switch {
    margin-left: 2rem;
  }

  &__language {
    display: flex;
    align-items: center;
    height: auto;
    padding-left: 2.5rem;
    font-size: 1.2rem;
    line-height: 1.5rem;
    font-weight: 600;
    color: $cAddDark02;
    transition: opacity $tr;

    &:hover {
      opacity: 0.6;
    }
  }

  &__languageFlag {
    margin-right: 10px;
  }

  &--showLoader {
    z-index: $zIndexLoader + 1;
  }
}
</style>
